export default __webpack_public_path__ + "static/media/imgComp4.f7d10524.webp";